import React, {useCallback} from 'react';
import {ExecutableModalProps} from "../../../../models/Modals";
import ExecutableModal from "../../../executableModal/ExecutableModal";
import {Button} from "antd";

type DateRangeWarningModalProps = ExecutableModalProps<{
  onApply: () => void | Promise<void>;
}>;

const DateRangeWarningModal = ({ onApply, handler }: DateRangeWarningModalProps) => {
  const submitClick = useCallback(() => {
    void onApply();
    handler.executeClose();
  }, [onApply]);

  const Footer = (
    <>
      <Button key={'cancel'} onClick={handler.executeClose}>
        Cancel
      </Button>
      <Button key={'apply'} type="primary" onClick={submitClick}>
        I understand
      </Button>
    </>
  );

  return (
    <ExecutableModal
      handler={handler}
      title={'Date Range Warning'}
      footer={Footer}
    >
      <p>
        Please note: The selected date range exceeds one month. Loading this
        data may take a significant amount of time.
      </p>
    </ExecutableModal>
  );
};

export default DateRangeWarningModal;